import { IconButton, mergeStyleSets, Modal, Stack } from "@fluentui/react";
import { useState } from "react";

import { EnergyOfferContract } from "../EnergyOffers";
import { TagOfferContract } from "../TagOffers/TagOfferContract";

import { CardPlan } from "./CardPlan";
import { PlanOfferContract } from "./PlanOfferContract";

import { Loader } from "@/components/Shared/Loader";
import {
  ListOfPlansOffers,
  Plan,
  PlanOfferItem
} from "@/modules/Offers/types/PlansOffers.types";

type PlansOffersProps = {
  plans?: ListOfPlansOffers;
  isLoadingList?: boolean;
  formType: "ENERGY" | "LINES" | "TAGS";
};

export function PlansOffers({
  plans,
  isLoadingList,
  formType
}: PlansOffersProps): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<Plan>(undefined);
  const [selectedCarrier, setSelectedCarrier] =
    useState<PlanOfferItem>(undefined);

  const toggleOpenModal = () => {
    setIsModalOpen(prevState => {
      return !prevState;
    });
  };

  const contractFormSwitcher = {
    LINES: (
      <PlanOfferContract
        selectedPlan={selectedPlan}
        selectedCarrier={selectedCarrier}
      />
    ),
    ENERGY: (
      <EnergyOfferContract
        selectedPlan={selectedPlan}
        selectedCarrier={selectedCarrier}
      />
    ),
    TAGS: (
      <TagOfferContract
        selectedPlan={selectedPlan}
        selectedCarrier={selectedCarrier}
      />
    )
  };

  return (
    <>
      {isLoadingList ? (
        <Loader height="300px" />
      ) : (
        plans?.map(plan => (
          <CardPlan
            key={plan.id}
            plan={plan}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            selectedCarrier={selectedCarrier}
            setSelectedCarrier={setSelectedCarrier}
            openModal={toggleOpenModal}
            formType={formType}
          />
        ))
      )}
      <Modal
        titleAriaId="Plan Contract Offer"
        isOpen={isModalOpen}
        onDismiss={toggleOpenModal}
        onDismissed={() => {
          setSelectedPlan(undefined);
          setSelectedCarrier(undefined);
        }}
        isBlocking={false}
        containerClassName={contentStyles.container}
        scrollableContentClassName={scrollableStyles.container}
      >
        <IconButton
          styles={{
            root: {
              zIndex: 1,
              position: "absolute",
              top: 10,
              right: 10
            }
          }}
          iconProps={{ iconName: "Cancel" }}
          ariaLabel="Close popup modal"
          onClick={toggleOpenModal}
        />

        {contractFormSwitcher[formType]}
      </Modal>
    </>
  );
}

const scrollableStyles = mergeStyleSets({
  container: {
    display: "flex"
  }
});

const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch"
  }
});
